import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {format as stringFormat} from 'react-string-format';

import {URL_IMG} from '../../../configs/urlConfigs';
import { MSG_CATEGORY_DELETE_ERROR,MSG_DELETE_CLIENT_CATEGORY_2, MSG_REQUIRED, MSG_NOT_FOUND, MSG_CLIENT_CATEGORY_ADD_SUCCESS, MSG_CLIENT_CATEGORY_UPDATE_SUCCESS, MSG_CLIENT_CATEGORY_DELETE_SUCCESS} from '../../../configs/msgConfigs';
import {LBL_CLIENT_CATEGORIES,LBL_ADD_NEW,LBL_APP_NAME,LBL_SETTINGS,LBL_CLIENT_CATEGORY,LBL_SLNUM,LBL_ACTIONS, LBL_DELETE,LBL_EDIT,LBL_CONFIRM_DELETE, LBL_SELECT,LBL_BACK_TO_SETTINGS} from '../../../configs/labelConfigs'; 
import {ROUTE_REFRESH,ROUTE_AFFILIATE_REFRESH,LOGIN_AFFILIATE_GROUP,ROUTE_AFFILIATE_SETTINGS} from '../../../configs/staticConfigs';

import ModalWindow from '../../commons/helpers/modalWindow';
import Toast from '../../commons/helpers/toast';

import {formValid} from '../../../utils/validation';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import {getSortClass,appendVenueLoc} from '../../../utils/commonUtilities';

import * as types from '../../../actions';
import {clientCategoryListAction, clientCategoryAddAction, clientCategoryEditAction, clientCategoryUpdateAction, clientCategoryDeleteAction} from '../../../actions/settings/affiliates/clientCategoryActions';
import { clientCategoryMasterListAction } from '../../../actions/settings/superadmin/clientCategoryActions';
import {clearAction} from '../../../actions/commonActions';

class ClientCategoryComponent extends Component { 

    constructor(props){
        super()

        this.state = {
            activePage:0,
            activeRowId:0,            
            formErrors:{
                clientCategoryName: MSG_REQUIRED,
            },          
            clientCategoryData:{
                clientCategoryId:'',
                clientCategoryName: null,                              
            },
            sortField:'name',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            clientCategoryMaster: [], 
            clientCategoriesItemsAddNew: [],
            addNewCategIds: [],
        }
        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSort = this.onSort.bind(this);
        this.modalDelete = React.createRef();
        this.modal = React.createRef();
    }
  
    openModal() {
        this.props.clientCategoryMasterListAction({page:0,column:this.state.sortOrder+this.state.sortField});
        let formErrors = this.state.formErrors;
        formErrors.clientCategoryName = MSG_REQUIRED;
        this.setState({formErrors, addNewCategIds:[],clientCategoryMaster:[]});
        this.modal.current.handleOpenModal();
    }  

    onModalFormReset = () =>{       
        this.setState({clientCategoryData:{
            clientCategoryId:'',
            clientCategoryName:null,
        }});              
    }

    onHandleChange = (event) =>{
        const {name, value} = event.target;

        let formErrors     = this.state.formErrors;
        let trimmedValue   = value.trim();
        switch(name){
            case 'clientCategoryName':
                formErrors.clientCategoryName = trimmedValue.length <=0 ? MSG_REQUIRED : ""
                break;            
            default :
            break;
        }

        let clientCategoryData   = this.state.clientCategoryData;
        clientCategoryData[name] = value;

        this.setState({formErrors,clientCategoryData});

    }

    onShowActionButtons = (event, rowId) =>{

        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }        
        
    }   
    
    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSaveFormData = (id) =>{
        if(this.state.addNewCategIds.length===0) {
            return false;
        }
        else {
            let affiliate = '';
            let userGroupData = userGroupUrlCheck(this.props.location);
            let userGroup    = ''; 
            let grpProfileId = ''; 
            if(userGroupData!==undefined){
                userGroup = userGroupData.user_group; 
                grpProfileId = userGroupData.profile_id;
            }
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                affiliate = grpProfileId;
            }
            let addData = {
                affiliate: affiliate,
                client_category_master:this.state.addNewCategIds
            }
            this.props.clientCategoryAddAction(addData);     
        }

        // if(formValid(this.state)){
        //     let formErrors = this.state.formErrors;  
        //     if(this.state.clientCategoryData.clientCategoryName==null || this.state.clientCategoryData.clientCategoryName.trim().length < 1){
        //         formErrors.clientCategoryName = MSG_REQUIRED;
        //     }
        //     else {
        //         let affiliate = '';
        //         let userGroupData = userGroupUrlCheck(this.props.location);
        //         let userGroup    = ''; 
        //         let grpProfileId = '';
        //         if(userGroupData!==undefined){
        //             userGroup = userGroupData.user_group; 
        //             grpProfileId = userGroupData.profile_id;
        //         }
        //         if(userGroup===LOGIN_AFFILIATE_GROUP){
        //             affiliate = grpProfileId;
        //         }
        //         if(id){            
        //             let clientCategoryData= {
        //                 id:id,
        //                 name: this.state.clientCategoryData.clientCategoryName,
        //                 affiliate                     
        //             } 
        //             this.props.clientCategoryUpdateAction(clientCategoryData);   
        //         }else{          
        //             let clientCategoryData= {
        //                 name: this.state.clientCategoryData.clientCategoryName, 
        //                 affiliate                     
        //             } 
        //             this.props.clientCategoryAddAction(clientCategoryData);           
        //         }  
        //     }
        //     this.setState({formErrors}); 
        // }else{
        //     let formErrors = this.state.formErrors;
        //     if(this.state.clientCategoryData.clientCategoryName==null || this.state.clientCategoryData.clientCategoryName.trim().length < 1){
        //         formErrors.clientCategoryName = MSG_REQUIRED;
        //     }            
        //     this.setState({formErrors});
        // }
    }

    editBtnClick = (rowId) =>{  
        let formErrors = this.state.formErrors;
        formErrors.clientCategoryName = '';
        this.setState(formErrors);
        this.modal.current.handleOpenModal();
        this.props.clientCategoryEditAction(rowId);
    }

    deleteBtnClick = (rowId,name) =>{
        this.setState({
            clientCategoryData: {
                clientCategoryId: rowId,   
                clientCategoryName:name            
            }
        }); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        let clientCategoryId = this.state.clientCategoryData.clientCategoryId;
        this.props.clientCategoryDeleteAction(clientCategoryId);
        this.modalDelete.current.handleModelClose();              
    }

    onSort = (event,sortKey) =>{        
        let sOrder = '';
        if(this.state.sortField===sortKey){         
            sOrder = (this.state.sortOrder==='-') ? '' : '-';
            this.props.clientCategoryListAction({page:this.state.activePage,column:sOrder+this.state.sortField});
            this.setState({ sortOrder:sOrder });            
        }else{
            this.setState({ sortField:sortKey });
            this.props.clientCategoryListAction({page:this.state.activePage,column:this.state.sortOrder+sortKey});
        }        
    }    
    
    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    } 

    setToasterState(isEnabled,message,isSucces,time=3000){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, time);
    }

    onSelectAddnewCheckbox = (event,categId) => { 
        let arrTemp = this.state.addNewCategIds; 
        if(event.target.checked) {
            if(!arrTemp.includes(categId)) {
                arrTemp.push(categId); 
            }
            this.setState({ addNewCategIds: arrTemp });
        }
        else {
            const index = arrTemp.indexOf(categId);
            if (index > -1) { 
                arrTemp.splice(index, 1); 
            }
            this.setState({ addNewCategIds: arrTemp });
        }            
    }
  
    setStateUpdate(clientCategory,status,activity,errorData){
        let formErrors = this.state.formErrors;
        if(activity===types.CLIENT_CATEGORY_ADD_SUCCESS){           
            this.modal.current.handleModelClose();
            this.props.clientCategoryListAction({page:this.state.activePage,column:this.state.sortOrder+this.state.sortField});
            this.setToasterState(true,MSG_CLIENT_CATEGORY_ADD_SUCCESS,true); 
        }else if(activity===types.CLIENT_CATEGORY_ADD_ERROR){ 
            if(status===400){
                if(errorData.hasOwnProperty('name')){
                    formErrors.clientCategoryName = errorData.name[0];                
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }      
            }    
        }else if(activity===types.CLIENT_CATEGORY_UPDATE_SUCCESS){            
            this.modal.current.handleModelClose();
            this.setToasterState(true,MSG_CLIENT_CATEGORY_UPDATE_SUCCESS,true);        
        }else if(activity===types.CLIENT_CATEGORY_UPDATE_ERROR){ 
            if(status===400){
                if(errorData.hasOwnProperty('name')){
                    formErrors.clientCategoryName = errorData.name[0];                
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }      
            }           
        }else if(activity===types.CLIENT_CATEGORY_EDIT_SUCCESS){ 
            this.setState({
                clientCategoryData:{
                    clientCategoryId:clientCategory.id,
                    clientCategoryName:clientCategory.name
                }
            }, () => {
                if(document.getElementById('clientCategoryName')) {
                    document.getElementById('clientCategoryName').focus(); 
                }
            });       
        }else if(activity===types.CLIENT_CATEGORY_DELETE_SUCCESS){
      
            this.props.clientCategoryListAction({page:this.state.activePage,column:this.state.sortOrder+this.state.sortField});
             
            this.setToasterState(true,MSG_CLIENT_CATEGORY_DELETE_SUCCESS,true);
        }else if(activity===types.CLIENT_CATEGORY_DELETE_ERROR){
            let userGroupData = userGroupUrlCheck(this.props.location);
            let userGroup = ''; 
            if(userGroupData!==undefined){
                userGroup = userGroupData.user_group; 
            }   
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                if(status===424){
                    this.setToasterState(true,errorData.message,false);
                }else if(status===405){
                    if(errorData.client_already_exists !== undefined && errorData.client_already_exists){
                        this.setToasterState(true,MSG_CATEGORY_DELETE_ERROR,false,6000);
                    }else{
                        this.setToasterState(true,JSON.stringify(errorData),false);
                    }
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false); 
                }
            }else{
                this.setToasterState(true,JSON.stringify(errorData),false);
            }
        }
    }
    
    componentDidUpdate(prevProps) {  
        const {clientCategory,status,activity,errorData, clientCategoriesMasterActivity, clientCategoriesMasterStatus, clientCategoriesMasterItems, clientCategoriesItems } = this.props;

        if (clientCategoriesMasterActivity && (clientCategoriesMasterStatus !== prevProps.clientCategoriesMasterStatus || clientCategoriesMasterActivity !== prevProps.clientCategoriesMasterActivity)) {
            if (clientCategoriesMasterActivity === types.CLIENT_CATEGORY_MASTER_LIST_SUCCESS && clientCategoriesMasterItems && clientCategoriesMasterItems.length > 0) {
                let arrAddCategs = [];
                clientCategoriesMasterItems.forEach(scItem => {
                    if (!clientCategoriesItems.find(item => item.client_category_master === scItem.id)) {
                        arrAddCategs.push(scItem);
                    }
                });
                this.setState({ clientCategoriesItemsAddNew: arrAddCategs });
            }
        }

        if (activity !== prevProps.activity) {
            this.setStateUpdate(clientCategory,status,activity,errorData);
            this.props.clearAction();
        }else{
        }        
    }

    componentDidMount() {      
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        this.props.clientCategoryListAction({page:this.state.activePage,column:this.state.sortOrder+this.state.sortField});    
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" -  "+LBL_CLIENT_CATEGORIES;
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
    }  

    render(){

        const {
            toastMessage,toastFlag,toastSuccess,clientCategoryData,sortField,sortOrder,clientCategoriesItemsAddNew,           
        } = this.state

        const { clientCategoriesItems,status,rowCount} = this.props;
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;

            }
        }

        return(
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                    <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={ROUTE_AFFILIATE_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                        <div className="to-right">                                   
                            <button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)}>{LBL_ADD_NEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table-other-exp" className="table" style={{width:"100%"}} >
                                <thead>
                                    <tr>
                                    <th>{LBL_SLNUM}</th>
                                    <th onClick={(e) => this.onSort(e,'name')} className="spanPointer">{LBL_CLIENT_CATEGORIES} <i className={sortField=='name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                    <th>{LBL_ACTIONS}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(rowCount===0) && 
                                    <tr>
                                        <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                {(rowCount!==0) && clientCategoriesItems.map((item,index) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{index+1}</td>
                                            <td>{item.name}</td>
                                            <td>
                                            <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)} >
                                                    {/* <img id="test" src={require('../../../'+URL_IMG+'action.png')} alt="Action" /> */}
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                    {/* <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link> */}
                                                    <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.name)}>{LBL_DELETE}</Link> 
                                                </div>
                                            </div>
                                            </td>
                                        </tr>             
                                        
                                     )
                                  })      

                                }                
                                </tbody>
                            </table>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {/* <span className='text-bold'>{stringFormat(MSG_DELETE_CLIENT_CATEGORY_1,"'"+clientCategoryData.clientCategoryName+"'")}</span> */}
                    {stringFormat(MSG_DELETE_CLIENT_CATEGORY_2,"'"+clientCategoryData.clientCategoryName+"'")}
                </ModalWindow>


                <ModalWindow ref={this.modal} header={Number(this.state.clientCategoryData.clientCategoryId) > 0 ? "Edit "+LBL_CLIENT_CATEGORY : "Add "+LBL_CLIENT_CATEGORY} saveFormData={ (e)=>this.onSaveFormData(clientCategoryData.clientCategoryId)} resetModalForm={this.onModalFormReset} >
                    <div className="row">
                        <table id="data-table" className="table" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th className='text-center widthPer10'>{LBL_SELECT}</th>
                                    <th>{LBL_CLIENT_CATEGORY}</th>
                                    <th >&nbsp;</th>
                                </tr>
                            </thead>

                            <tbody>
                                {!clientCategoriesItemsAddNew || !Array.isArray(clientCategoriesItemsAddNew) || clientCategoriesItemsAddNew.length === 0 &&
                                    <tr>
                                        <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                {clientCategoriesItemsAddNew.map((item, index) => {
                                    return (
                                        <tr key={item.id}>
                                            <td className='text-center'>
                                                <div className="form-group">
                                                    <div className="checkbox-wrapper">
                                                        <div className="custom-checkbox">
                                                            <input name={"chk_categ"+index} type="checkbox" id={"chk_categ"+index} checked={this.state.addNewCategIds.includes(item.id) ? true : false} onChange={(e) => this.onSelectAddnewCheckbox(e,item.id)} />
                                                            <label className="checkbox" htmlFor={"chk_categ"+index}></label>
                                                            <label className="labeltext" htmlFor={"chk_categ"+index}>{''}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{item.name}</td>
                                            <td >&nbsp;</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>

                    </div>
                    {/* <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>{LBL_CLIENT_CATEGORY}</label>
                                <div className="text-input">
                                <input className={this.state.formErrors.clientCategoryName.length >0 ? 'input-error' : ''} type="text" name="clientCategoryName" id="clientCategoryName" value={clientCategoryData.clientCategoryName || ''} onChange={this.onHandleChange} placeholder="" maxLength={120} />
                                    {this.state.formErrors.clientCategoryName.length >0 && this.state.formErrors.clientCategoryName!=MSG_REQUIRED && (
                                        <div className="text-red left-align text-12">{this.state.formErrors.clientCategoryName}</div>
                                    )} 
                                </div>
                            </div>
                        </div>
                    </div> */}
                </ModalWindow>
            </div>
        )
        
    }
    
}
const mapStateToProps = (state) => {
    console.log('state.clientMasterCategories.items: ',state.clientMasterCategories.items); 
    return {
        clientCategoriesItems : state.clientCategories.items,
        clientCategory:state.clientCategories.item,
        status:state.clientCategories.status,
        activity:state.clientCategories.activity,
        rowCount:state.clientCategories.count,
        errorData:state.clientCategories.errorData,
        clientCategoriesMasterItems : state.clientMasterCategories.items,
        clientCategoriesMasterActivity:state.clientMasterCategories.activity,
        clientCategoriesMasterStatus:state.clientMasterCategories.status,
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        clientCategoryListAction:clientCategoryListAction,  
        clientCategoryMasterListAction:clientCategoryMasterListAction,
        clientCategoryAddAction:data=>clientCategoryAddAction(data),
        clientCategoryEditAction:id=>clientCategoryEditAction(id),
        clientCategoryUpdateAction:data=>clientCategoryUpdateAction(data),
        clientCategoryDeleteAction:id=>clientCategoryDeleteAction(id),
        clearAction:clearAction
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(ClientCategoryComponent);